import { createSlice } from "@reduxjs/toolkit";
import { getCoopTransactions } from "../actions/coopTransactions/getCoopTransactions";
import { getCoopTransactionsSummary } from "../actions/coopTransactions/getCoopTransactionsSummary";

export const coopTransactionsSlice = createSlice({
  name: "coopTransactions",
  initialState: {
    error: null,
    pending: false,
    summaryPending: false,
    transactions: [],
    transactionsInfo: null,
    summary: null,
  },

  reducers: {},

  extraReducers: (builder) => {
    // List
    builder.addCase(getCoopTransactions.pending, (state) => {
      state.pending = true;
    });
    builder.addCase(getCoopTransactions.fulfilled, (state, action) => {
      state.pending = false;
      state.transactions = action.payload?.data || [];
      state.transactionsInfo = action.payload;
    });
    builder.addCase(getCoopTransactions.rejected, (state, action) => {
      state.pending = false;
      state.error = action?.payload;
    });

    // Summary
    builder.addCase(getCoopTransactionsSummary.pending, (state) => {
      state.summaryPending = true;
    });
    builder.addCase(getCoopTransactionsSummary.fulfilled, (state, action) => {
      state.summaryPending = false;
      state.summary = action.payload;
    });
    builder.addCase(getCoopTransactionsSummary.rejected, (state, action) => {
      state.summaryPending = false;
      state.error = action?.payload;
    });
  },
});

export default coopTransactionsSlice.reducer;
